import { jsx as r, Fragment as b } from "react/jsx-runtime";
import "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import x from "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import y from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import d from "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import k from "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import { Link as S } from "@propify-tenant-client/common";
import { memo as C } from "react";
const p = 25, i = p * 1.5, T = (o) => y({
  point: {
    position: "absolute",
    width: p,
    height: p,
    left: -25 / 2,
    top: -25 / 2,
    border: (t) => `4px solid ${t.open ? o.palette.primary.light : t.color ?? o.palette.primary.main}`,
    borderRadius: p,
    backgroundColor: "white",
    textAlign: "center",
    color: "#3f51b5",
    fontSize: 16,
    fontWeight: "bold",
    padding: 4,
    cursor: "pointer",
    "&:hover": {
      border: `4px solid ${o.palette.primary.light}`,
      color: "#f44336"
    }
  },
  cluster: {
    position: "absolute",
    width: i,
    height: i,
    left: -37.5 / 2,
    top: -37.5 / 2,
    border: "0px solid transparent",
    color: o.palette.primary.contrastText,
    borderRadius: i,
    backgroundColor: o.palette.primary.main,
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    padding: `${i / 4}px 0`,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: o.palette.primary.light
    }
  }
}), W = d(
  () => ({
    popper: {
      zIndex: 1299
    },
    tooltip: {
      backgroundColor: "#fff",
      color: "#000",
      maxWidth: 350,
      fontSize: "0.9em",
      border: "1px solid #ddd",
      pointerEvents: "auto"
    }
  }),
  { name: "Tooltip" }
)(k), L = ({
  onActivePlace: o,
  onClick: t,
  open: e,
  index: s,
  children: m,
  classes: n,
  to: l,
  content: c,
  isCluster: f
}) => {
  const g = (h) => {
    typeof o == "function" && o(e ? void 0 : { index: s, source: "geotag" }), typeof t == "function" && t(h);
  }, u = f ? n.cluster : n.point, a = /* @__PURE__ */ r("div", { className: u, onClick: g, children: c });
  return m ? /* @__PURE__ */ r(W, { title: l ? /* @__PURE__ */ r(x, { component: S, to: l, children: m }) : /* @__PURE__ */ r(b, { children: m }), placement: "top", open: e, children: a }) : a;
}, Lo = d(T, { name: "Geotag" })(C(L));
export {
  p as TAG_SIZE,
  Lo as default
};
//# sourceMappingURL=Geotag.js.map
